import { render } from "./AnchorNavigation.vue?vue&type=template&id=7859e66a&scoped=true"
import script from "./AnchorNavigation.vue?vue&type=script&lang=js"
export * from "./AnchorNavigation.vue?vue&type=script&lang=js"

import "./AnchorNavigation.vue?vue&type=style&index=0&id=7859e66a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7859e66a"]])

export default __exports__